/* eslint-disable max-lines -- словарь текстов всех утилит `features/editor/lib`: одна
   пара ru/en на каталог, делить его по файлам значит потерять единый реестр терминов. */
import { defineMessages, enPlural } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // reviewLockText.ts
    reviewLock: 'Курс на проверке — правка недоступна до решения.',
    reviewChangeRefused: 'Курс на проверке — изменение недоступно',
    reviewUploadRefused: 'Курс на проверке — картинка не сохранена',
    draftSettlingRefused: 'Подождите: студия переходит на черновик курса',

    // courseLanguages.ts
    statusFreshLabel: 'Перевод актуален',
    statusFreshHint: 'Базовая версия не менялась после перевода',
    statusOutdatedLabel: 'Требует обновления',
    statusOutdatedHint:
      'После перевода в базовой версии правили тексты уроков или блоков либо добавили новые',
    statusPartialLabel: 'Переведён частично',
    statusPartialHint: 'Часть уроков и блоков ещё без перевода',
    statusUntranslatedLabel: 'Не переведён',
    statusUntranslatedHint: 'Переводов на этот язык пока нет',

    // publishIssues.ts
    fieldName: 'Название',
    fieldDescription: 'Описание',
    noBlocks: 'Нет ни одного блока',
    noLessons: 'Нет ни одного урока',
    noVideo: 'Не загружено видео',
    noCorrectAnswer: 'Не выбран правильный ответ',
    tooFewCorrect: 'Выберите минимум 2 правильных ответа',
    noQuestion: 'Не введён вопрос',
    noGap: 'В утверждении нет пропуска',
    noDesignImage: 'Не загружена картинка',
    emptyDesign: 'Пустой составной блок',
    emptyDesignText: 'В составном блоке есть пустой текст',
    incompleteTable: 'Заполните таблицу до конца',
    designOverflow: 'Составной блок не помещается на экран',
    designOverflowWarn: 'Много текста — рекомендуем сократить',
    tooFewAnswers: (n: number) => `Нужно минимум ${n} варианта ответа`,
    tooFewPairs: 'Нужно минимум 2 пары',
    emptyAnswers: 'Не заполнены варианты ответа',
    emptyPairs: 'Не заполнены пары',

    // publishErrorText.ts
    publishWhereCourse: 'Курс',
    publishWhereLessonBlock: (lesson: string, block: string) => `Урок ${lesson}, блок ${block}`,
    publishNoDescription: 'Не заполнено описание курса',
    publishNoDescriptionHint: 'Настройки курса → Основное',
    publishNoVideo: 'Не загружен ролик в видео-блоке',
    publishNoVideoHint: 'Загрузите видео или удалите пустой блок',
    publishMatchFewPairs: 'В блоке «Соответствие» меньше двух пар',
    publishMatchFewPairsHint: 'Добавьте ещё пару или удалите блок',
    publishNoArticle: 'Не выбрана статья в блоке статьи',
    publishNoArticleHint: 'Выберите статью или удалите пустой блок',
    publishWhereLessonBlockOf: (lesson: string, type: string) => `Урок «${lesson}», блок «${type}»`,
    publishWhereQuiz: 'Квиз',

    // lessonLook.ts
    lookMixedPattern: 'В блоках разные паттерны',
    lookMixedTheme: 'Тема применилась не ко всем блокам — выберите её ещё раз',
    lookPickThemeFirst: 'Сначала выберите тему',

    // emptyVideoBlocks.ts
    emptyVideoRefusal: (places: Array<{ lesson: number; block: number }>) =>
      `Нельзя опубликовать: не загружено видео — ${places
        .map((p) => `урок ${p.lesson}, блок ${p.block}`)
        .join('; ')}. Загрузите ролик в эти блоки.`,

    // publishIssues.ts: отказ повысить доступ курсу с переполненным составным блоком
    designOverflowRefusal: (places: string[]) =>
      `Составной блок не помещается на экран: ${places.join(', ')}`,
    designOverflowPlace: (lesson: number, screen: number, lang: string) =>
      `Урок ${lesson}, экран ${screen}${lang === 'EN' ? ' (EN)' : ''}`,

    // coursePatch.ts
    priceZeroOrMin: (min: string) => `Цена должна быть 0 или не меньше ${min}`,
    priceMin: (min: string) => `Цена должна быть не меньше ${min}`,
    priceNegative: 'Цена не может быть отрицательной',

    // parseBlockError.ts
    blockSaveFailed: 'Не удалось сохранить блок. Попробуйте ещё раз.',

    // quizWordLimits.ts
    wordNoun: (n: number): string => (n === 1 ? 'слово' : n >= 2 && n <= 4 ? 'слова' : 'слов'),

    // badgeVariants.ts
    badgeFill: 'Заливка',
    badgeOutline: 'Контур',
    badgeVolume: 'Объём',
    iconNone: 'Без иконки',
    iconLucide: 'С иконкой',
    iconCustom: 'Своя',

    // monetizationFaq.ts
    faqSubPayoutQ: 'Как автор получает деньги, если курс в подписке?',
    faqSubPayoutA:
      'По стриминговой модели: 40% наших доходов с подписок после вычета налогов, комиссий ' +
      'магазинов приложений и эквайринга ежемесячно распределяется между авторами пропорционально ' +
      'просмотрам их курсов. Чем чаще смотрят ваш курс, тем больше ваша ' +
      'доля. Подробнее о результатах — в статистике курса.',
    faqSubWhoQ: 'Кто может смотреть курс, который есть в подписке?',
    faqSubWhoA: 'Пользователь с Premium-подпиской может смотреть курс, пока подписка активна.',
    faqSubViewsQ: 'Где посмотреть, сколько просмотров у курса?',
    faqSubViewsA:
      'В статистике курса: пункт «Статистика» в меню «•••» на карточке курса. Там видны ' +
      'просмотры, рейтинг, число отзывов и сколько человек прошли курс.',
    faqSubEndsQ: 'Что происходит, когда у ученика заканчивается подписка?',
    faqSubEndsA:
      'Курс перестаёт быть доступен, когда подписка заканчивается, даже если ученик его прошёл. ' +
      'После возобновления подписки курс снова открывается, прогресс сохраняется — его нужно ' +
      'ещё раз взять по подписке той же кнопкой.',
    faqSaleFeeQ: 'Сколько платформа берёт с продаж?',
    faqSaleFeeA: 'Комиссия платформы с разовых продаж — 20%.',
    faqSaleTwoPricesQ: 'Почему нужно указать две цены?',
    faqSaleTwoPricesA:
      'У курса две независимые цены: в рублях и в долларах. Покупатели из России платят в ' +
      'рублях, из остальных стран — в долларах, поэтому студия просит обе цены.',
    faqSaleMinQ: 'Какая минимальная цена?',
    faqSaleMinA: (rub: number, usd: string) =>
      `${rub} ₽ и ${usd} $ — это минимумы платёжных систем. ` +
      'Дешевле студия не даст поставить: поле само встанет на минимум.',
    faqSaleBuyerQ: 'Что получает покупатель?',
    faqSaleBuyerA:
      'Курс остаётся у него навсегда, вместе с пожизненными обновлениями: все уроки, которые вы ' +
      'добавите позже, он получит без доплаты.',
    faqSaleTrialQ: 'Что такое триал-доступ?',
    faqSaleTrialA:
      'Первые уроки, которые ученик проходит бесплатно, до оплаты. Бесплатных уроков может быть не ' +
      'больше трёх, и хотя бы один урок всегда остаётся платным, поэтому для триала в курсе ' +
      'должно быть минимум два урока.',
  },
  en: {
    reviewLock: 'The course is under review — you can’t edit it until the review is done.',
    reviewChangeRefused: 'The course is under review — changes aren’t allowed right now',
    reviewUploadRefused: 'The course is under review — the image wasn’t saved',
    draftSettlingRefused: 'Hold on — the studio is switching to the course draft',

    statusFreshLabel: 'Up to date',
    statusFreshHint: 'The source version hasn’t changed since the translation',
    statusOutdatedLabel: 'Out of date',
    statusOutdatedHint:
      'Since the translation, lesson or block texts in the source version were edited, or new ones were added',
    statusPartialLabel: 'Partially translated',
    statusPartialHint: 'Some lessons and blocks aren’t translated yet',
    statusUntranslatedLabel: 'Not translated',
    statusUntranslatedHint: 'No translations into this language yet',

    fieldName: 'Title',
    fieldDescription: 'Description',
    noBlocks: 'No blocks',
    noLessons: 'No lessons',
    noVideo: 'Video not uploaded',
    noCorrectAnswer: 'No correct answer selected',
    tooFewCorrect: 'Select at least 2 correct answers',
    noQuestion: 'No question entered',
    noGap: 'No blank in the statement',
    noDesignImage: 'Image not uploaded',
    emptyDesign: 'Empty composite block',
    emptyDesignText: 'Composite block has empty text',
    incompleteTable: 'Fill in every table cell',
    designOverflow: 'Composite block doesn’t fit the screen',
    designOverflowWarn: 'Too much text — we recommend shortening',
    tooFewAnswers: (n: number) => `Add at least ${n} answer options`,
    tooFewPairs: 'Add at least 2 pairs',
    emptyAnswers: 'Some answer options are empty',
    emptyPairs: 'Some pairs are empty',

    publishWhereCourse: 'Course',
    publishWhereLessonBlock: (lesson: string, block: string) => `Lesson ${lesson}, block ${block}`,
    publishNoDescription: 'Course description is missing',
    publishNoDescriptionHint: 'Course settings → General',
    publishNoVideo: 'No video uploaded in a video block',
    publishNoVideoHint: 'Upload a video or delete the empty block',
    publishMatchFewPairs: 'A match block has fewer than two pairs',
    publishMatchFewPairsHint: 'Add another pair or delete the block',
    publishNoArticle: 'No article selected in an article block',
    publishNoArticleHint: 'Select an article or delete the empty block',
    publishWhereLessonBlockOf: (lesson: string, type: string) =>
      `Lesson “${lesson}”, block “${type}”`,
    publishWhereQuiz: 'Quiz',

    lookMixedPattern: 'Blocks use different patterns',
    lookMixedTheme: 'The theme wasn’t applied to all blocks — select it again',
    lookPickThemeFirst: 'Select a theme first',

    emptyVideoRefusal: (places: Array<{ lesson: number; block: number }>) =>
      `Can’t publish: video not uploaded — ${places
        .map((p) => `lesson ${p.lesson}, block ${p.block}`)
        .join('; ')}. Upload a video to these blocks.`,

    designOverflowRefusal: (places: string[]) =>
      `Composite block doesn’t fit the screen: ${places.join(', ')}`,
    designOverflowPlace: (lesson: number, screen: number, lang: string) =>
      `Lesson ${lesson}, screen ${screen}${lang === 'EN' ? ' (EN)' : ''}`,

    priceZeroOrMin: (min: string) => `Price must be 0 or at least ${min}`,
    priceMin: (min: string) => `Price must be at least ${min}`,
    priceNegative: 'Price can’t be negative',

    blockSaveFailed: 'Couldn’t save the block. Try again.',

    wordNoun: (n: number) => enPlural(n, 'word', 'words'),

    badgeFill: 'Fill',
    badgeOutline: 'Outline',
    badgeVolume: 'Soft',
    iconNone: 'No icon',
    iconLucide: 'With icon',
    iconCustom: 'Custom',

    faqSubPayoutQ: 'How do authors get paid when a course is in the subscription?',
    faqSubPayoutA:
      'Through a streaming model: each month, 40% of our subscription revenue after taxes, app ' +
      'store fees and payment processing fees is split between authors in proportion to views of their courses. ' +
      'The more your course is viewed, the bigger your share. You can track the results in course statistics.',
    faqSubWhoQ: 'Who can view a course that’s in the subscription?',
    faqSubWhoA: 'Anyone with a Premium subscription can view the course while it’s active.',
    faqSubViewsQ: 'Where can I see how many views a course has?',
    faqSubViewsA:
      'In course statistics: “Statistics” in the “•••” menu on the course card. It shows views, rating, ' +
      'number of reviews and how many people completed the course.',
    faqSubEndsQ: 'What happens when a learner’s subscription ends?',
    faqSubEndsA:
      'The course stops being available when the subscription ends, even if the learner completed ' +
      'it. Once the subscription is renewed, the course opens again with progress kept — the learner ' +
      'just needs to add it via the subscription again with the same button.',
    faqSaleFeeQ: 'How much does the platform take from sales?',
    faqSaleFeeA: 'The platform fee on one-time sales is 20%.',
    faqSaleTwoPricesQ: 'Why do I need to set two prices?',
    faqSaleTwoPricesA:
      'A course has two independent prices: in rubles and in dollars. Buyers in Russia pay in ' +
      'rubles, everyone else in dollars, so the studio asks for both.',
    faqSaleMinQ: 'What’s the minimum price?',
    faqSaleMinA: (rub: number, usd: string) =>
      `${rub} ₽ and $${usd} are the payment providers’ minimums. ` +
      'The studio won’t let you go lower: the field snaps to the minimum.',
    faqSaleBuyerQ: 'What does the buyer get?',
    faqSaleBuyerA:
      'The course stays with them forever, with lifetime updates: any lessons you add later ' +
      'come at no extra cost.',
    faqSaleTrialQ: 'What is trial access?',
    faqSaleTrialA:
      'The first lessons a learner can take for free before paying. There can be at most three ' +
      'free lessons, and at least one lesson always stays paid, so a trial needs at least two ' +
      'lessons in the course.',
  },
})
